import { Point } from '../../platform/geom/Point';
import { PropertyValueType } from './Interfaces';

export const PointType: PropertyValueType<Point> = Object.freeze({
    name: 'Point',
    byRef: true,
    fromString(value: string): [boolean, Point] {
        try {
            if (!!value) {
                return [true, Point.parse(value)];
            }
        }
        catch { // Ignore

        }
        return [false, null];
    },
    serialize(value: Point): any {
        if (!value) return [0, 0];
        return [value.x, value.y];
    },
    deserialize(value: any, defau1t?: Point): Point {
        if (Array.isArray(value)) {
            return Point.from(value);
        }
        const [ok, dt] = PointType.fromString(value);
        return dt ?? defau1t ?? Point.zero;
    },
});
